import { render, staticRenderFns } from "./AccordionGroup.vue?vue&type=template&id=3bd6007e&scoped=true"
import script from "./AccordionGroup.vue?vue&type=script&lang=js"
export * from "./AccordionGroup.vue?vue&type=script&lang=js"
import style0 from "./AccordionGroup.vue?vue&type=style&index=0&id=3bd6007e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd6007e",
  null
  
)

export default component.exports